
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/sneeuwhoogtes-sneeuwbericht",
      function () {
        return require("private-next-pages/[region]/sneeuwhoogtes-sneeuwbericht.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/sneeuwhoogtes-sneeuwbericht"])
      });
    }
  